<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20">
    <p class="w100 font-16">车辆申请记录</p>
    <div class="w100 pt20 pb20 cl-f">
      <SiftComp class="flex-1" ref="sift" :sift-data="siftData" :loading="loading" @click-search="page = 1, fetchList()" />
      <div class="tx-r">
        <el-button type="primary" @click="page = 1, fetchList()" :loading="loading">查询</el-button>
      </div>
    </div>

    <el-table class="w100" :data="list" stripe border height="550">
      <el-table-column align="center" label="车牌号" prop="carNo"></el-table-column>
      <el-table-column align="center" label="用车人" prop="user"></el-table-column>
      <el-table-column align="center" label="事由" prop="reason"></el-table-column>
      <el-table-column align="center" label="目的地" prop="destination"></el-table-column>
      <el-table-column align="center" label="开始时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.status == '可用' ? 'green' : 'red'">{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="80">
        <template slot-scope="scope">
          <span class="blue cu-p" @click="showMsg(scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow">
      <span class="font-16" slot="title" v-if="selData">{{ selData.carNo }}</span>
      <div class="w100">
        <table class="w100 table-view" v-if="selData">
          <tbody>
            <tr>
              <td>车牌号</td>
              <td>{{ selData.carNo }}</td>
            </tr>
            <tr>
              <td>申请人</td>
              <td>{{ selData.applyMan }}</td>
            </tr>
            <tr>
              <td>申请时间</td>
              <td>{{ selData.applyDate | filterDate('yyyy-MM-dd hh:mm:ss') }}</td>
            </tr>
            <tr>
              <td>用车人</td>
              <td>{{ selData.user }}</td>
            </tr>
            <tr>
              <td>用车部门</td>
              <td>{{ selData.useDept }}</td>
            </tr>
            <tr>
              <td>随行人员</td>
              <td>{{ selData.retinue }}</td>
            </tr>
            <tr>
              <td>事由</td>
              <td>{{ selData.reason }}</td>
            </tr>
            <tr>
              <td>开始时间</td>
              <td>{{ selData.startTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</td>
            </tr>
            <tr>
              <td>结束时间</td>
              <td>{{ selData.endTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</td>
            </tr>
            <tr>
              <td>目的地</td>
              <td>{{ selData.destination }}</td>
            </tr>
            <tr>
              <td>申请里程</td>
              <td>{{ selData.applyMileage }}</td>
            </tr>
            <tr>
              <td>调度员</td>
              <td>{{ selData.yardman }}</td>
            </tr>
            <tr>
              <td>备选调度员</td>
              <td>{{ selData.alternativeYardman }}</td>
            </tr>
            <tr>
              <td>部门审批人</td>
              <td>{{ selData.departmentApprover }}</td>
            </tr>
            <tr>
              <td>状态</td>
              <td :class="selData.status == '待批' ? 'red' : 'green'">{{ selData.status }}</td>
            </tr>
            <tr>
              <td>备注</td>
              <td>{{ selData.remark }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "OfficeCarHistory",
  components: {
    SiftComp,
  },
  props: [],
  data() {
    return {
      loading: false,

      siftData: [
        {
          label: "状态",
          type: "select",
          key: "status",
          data: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "active",
              label: "待批",
            },
            {
              value: "end",
              label: "已准",
            },
            {
              value: "terminate",
              label: "未准",
            },
          ],
        },
        {
          label: "车牌号",
          type: "text",
          key: "carNo",
        },
        {
          label: "用车人",
          type: "text",
          key: "user",
        },
        {
          label: "用车部门",
          type: "text",
          key: "useDept",
        },
        {
          key: "startDate,endDate",
          label: "申请时间",
          type: "bedate",
        },
        {
          label: "调度员",
          type: "text",
          key: "yardMan",
        },
        {
          label: "申请人",
          type: "text",
          key: "applyMan",
        },
      ],

      list: [],
      page: 1,
      size: 30,
      total: 0,

      isShow: false,
      selData: null,
    };
  },
  computed: {
    ...mapState(["userData"]),
  },
  created() {},
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.pageNum = this.page;
      obj.pageSize = this.size;

      this.loading = true;
      this.$http
        .post("car/query/record", this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error",
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error",
          });
          this.loading = false;
        });
    },
    showMsg(obj) {
      // console.log(obj);
      this.loading = true;
      this.$http
        .post(
          "car/query/recordDetail",
          this.$qs.stringify({
            id: obj.id,
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.selData = data.resData;
            this.$nextTick(() => {
              this.isShow = true;
            });
          } else {
            this.$message({
              message: data.resMsg,
              type: "error",
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error",
          });
          this.loading = false;
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
  },
  watch: {},
};
</script>

<style scoped>
.table-view {
  border-collapse: collapse;
}
.table-view td {
  padding: 10px;
  border: 1px solid #dddddd;
}
.table-view tr td:first-child {
  min-width: calc(5em + 20px);
  background: #efefef;
}
</style>
